import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 py-4">
      <button
        className="flex justify-between items-center w-full text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-lg font-medium">{question}</span>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="mt-2 text-gray-600"
          >
            {answer}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const faqData = [
    {
      question: "Qu'est-ce qu'un code USSD ?",
      answer: "Un code USSD (Unstructured Supplementary Service Data) est une séquence de chiffres qui commence par * ou # et se termine par #. Il permet d'accéder rapidement à des services spécifiques de votre opérateur mobile."
    },
    {
      question: "Comment utiliser un code USSD ?",
      answer: "Pour utiliser un code USSD, composez simplement le code sur votre téléphone comme si vous alliez passer un appel, puis appuyez sur la touche d'appel. Un menu ou un message apparaîtra alors sur votre écran."
    },
    {
      question: "Les codes USSD sont-ils gratuits ?",
      answer: "La plupart des codes USSD sont gratuits à utiliser. Cependant, certains services accessibles via ces codes peuvent être payants. Vérifiez toujours les conditions auprès de votre opérateur."
    },
    {
      question: "Puis-je utiliser ces codes sur tous les téléphones ?",
      answer: "Oui, les codes USSD fonctionnent sur tous les téléphones mobiles, qu'il s'agisse de smartphones ou de téléphones basiques."
    },
  ];

  return (
    <div className="mt-24">
      <h2 className="text-3xl font-semibold text-center mb-8">Foire Aux Questions</h2>
      <div className="max-w-2xl mx-auto">
        {faqData.map((item, index) => (
          <FAQItem key={index} question={item.question} answer={item.answer} />
        ))}
      </div>
    </div>
  );
};

export default FAQ;